import { render, staticRenderFns } from "./cqc.vue?vue&type=template&id=1a1c568b&scoped=true&"
import script from "./cqc.vue?vue&type=script&lang=js&"
export * from "./cqc.vue?vue&type=script&lang=js&"
import style0 from "./cqc.vue?vue&type=style&index=0&id=1a1c568b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a1c568b",
  null
  
)

export default component.exports